import { SignIn, SignUp } from '@clerk/clerk-react';
import { getTenantBasePath } from '@low6-pickem/frontend-shared';
import { useRef } from 'react';

import { ProgressBar } from '@/components/ui/progress-bar';

import { clerkAppearance } from './clerkAppearance';
import { useClerkSignUpProgress } from './useClerkSignUpProgress';

const TENANT_BASE_PATH = getTenantBasePath();

export function SignInPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-sm">
        <SignIn
          routing="path"
          path={`${TENANT_BASE_PATH}/sign-in`}
          signUpUrl={`${TENANT_BASE_PATH}/sign-up`}
          appearance={clerkAppearance}
        />
      </div>
    </div>
  );
}

export function SignUpPage() {
  const formContainerRef = useRef<HTMLDivElement>(null);
  const progress = useClerkSignUpProgress(formContainerRef);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      {/* Figma header-bar progress — bg surface, top border, 24px padding */}
      <div className="w-full border-t border-border bg-surface px-4 py-6">
        <div className="mx-auto w-full max-w-sm">
          <ProgressBar value={progress} variant="flat" />
        </div>
      </div>

      <div className="flex flex-1 justify-center px-4 py-10">
        <div ref={formContainerRef} className="w-full max-w-sm">
          <SignUp
            routing="path"
            path={`${TENANT_BASE_PATH}/sign-up`}
            signInUrl={`${TENANT_BASE_PATH}/sign-in`}
            appearance={clerkAppearance}
          />
        </div>
      </div>
    </div>
  );
}
